//@ts-ignore
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import _ from "lodash";
import styled, { css } from "styled-components";
import moment from 'moment';
import { DormitoryTab } from "./dormitories-page";
import { cutString } from "./search-results-page";

import Select from "react-select";
import Sidebar from "arui-feather/sidebar";

// import Select from "components/ui-kit/select";
import { Breadcrumb, Button, Container, Frame, Row, RowWrapper, PhotoDropzone } from "components/ui-kit/styled-templates";
import { Control } from "components/ui-kit/control";

import ArticlesAPI from "api/articles-api";
import ExternalNewsAPI, { ExternalNewsItem } from "api/external-news-api";

import useBodyBackground from "hooks/useBodyBackground";
import { useStorageListener } from "hooks/useStorage";

import { ERoles } from "types/enums";
import { resolveFileUrl } from "constants/config";
import PostsAPI from "../../api/PostsAPI";
import { renderPosts } from "../posts/panels/AdminPostsPanel";
import toast from "react-hot-toast";


const twoArraysIntersection = (a: any[], b: any[]) => {
    return a.filter((x: any) => b.includes(x));
};

const NewsListPage = () => {
    const { t, i18n } = useTranslation();
    let isRu = i18n.language === "ru";

    const AMB_OPTIONS = [
        { value: "all", label: isRu ? "Все новости" : "All news" },
        { value: "platform", label: isRu ? "Новости программы" : "Program news" },
        { value: "ambassadors", label: isRu ? "Новости амбассадоров" : "Ambassadors news" },
        { value: "external", label: isRu ? "О нас говорят" : "Media about us" }
    ];


    const [mode, setMode] = useState(AMB_OPTIONS[0].value);

    useBodyBackground("white");
    const role: ERoles = useStorageListener(`user.userRole`, ERoles.Guest);
    const articles = useStorageListener(`news`, []);
    const [posts, setPosts] = useState([]);

    // External news state
    const [externalNews, setExternalNews] = useState<ExternalNewsItem[]>([]);
    const [externalNewsLoading, setExternalNewsLoading] = useState(false);
    const [externalNewsModalVisible, setExternalNewsModalVisible] = useState(false);
    const [editingExternalNews, setEditingExternalNews] = useState<ExternalNewsItem | null>(null);
    const [externalNewsForm, setExternalNewsForm] = useState<ExternalNewsItem>({
        image: '',
        sourceName: '',
        title: '',
        url: '',
        publishDate: ''
    });

    const [selectedTags, setSelectedTags] = useState<string[]>([]);
    const [maxLength, setMaxLength] = useState(12);

    const tagsToSelect = _(articles).values().map("tags").filter(_.identity).flatten().uniq().value();
    let nowDate = moment().format('DD.MM.YYYY HH:mm');
    let xValues = _(articles).values().map(x => {
        let cDate = x.customDate;
        if (cDate == undefined){
            cDate = moment(x.timestamp).format('DD.MM.YYYY HH:mm');
        }
        return {
            ...x,
            customDate: cDate
        }
    });
    // if not admin, filter by current date
    if (role !== ERoles.Admin){
        xValues = xValues.filter(x => (+moment(x.customDate, 'DD.MM.YYYY HH:mm') < +moment(nowDate, 'DD.MM.YYYY HH:mm')));
    }

    xValues = xValues.sort((a, b) => {
        // compare by custom date
        if (+moment(a.customDate, 'DD.MM.YYYY HH:mm') < +moment(b.customDate, 'DD.MM.YYYY HH:mm')) {
            return 1;
        }
        if ((+moment(a.customDate, 'DD.MM.YYYY HH:mm')) > +moment(b.customDate, 'DD.MM.YYYY HH:mm')) {
            return -1;
        }
        return 0;
    });
    // filter by tags
    const filteredArticles = xValues
        .filter((i) => i?.tags?.some?.((j) => selectedTags?.includes?.(j)) || selectedTags?.length === 0)
        .value();

    // const filteredArticles = xValues
    //     .orderBy("createdTimestamp", "desc")
    //     .filter((i) => i?.tags?.some?.((j) => selectedTags?.includes?.(j)) || selectedTags?.length === 0)
    //     .value();

    const handlers = {
        increaseMaxLength: () => {
            setMaxLength(maxLength + 6);
        }
    };

    const loadExternalNews = async () => {
        setExternalNewsLoading(true);
        const news = await ExternalNewsAPI.getAllExternalNews();
        // Sort by createdTimestamp descending (newest first)
        const sortedNews = news.sort((a, b) => (b.createdTimestamp || 0) - (a.createdTimestamp || 0));
        setExternalNews(sortedNews);
        setExternalNewsLoading(false);
    };

    const handleSaveExternalNews = async () => {
        if (!externalNewsForm.sourceName || !externalNewsForm.title || !externalNewsForm.url) {
            toast.error(isRu ? 'Заполните все обязательные поля' : 'Fill in all required fields');
            return;
        }

        if (editingExternalNews?.id) {
            await ExternalNewsAPI.updateExternalNews({ ...externalNewsForm, id: editingExternalNews.id });
        } else {
            await ExternalNewsAPI.createExternalNews(externalNewsForm);
        }

        setExternalNewsModalVisible(false);
        setEditingExternalNews(null);
        setExternalNewsForm({ image: '', sourceName: '', title: '', url: '', publishDate: '' });
        loadExternalNews();
    };

    const handleDeleteExternalNews = async (id: string) => {
        if (!window.confirm(isRu ? 'Удалить эту новость?' : 'Delete this news?')) return;
        await ExternalNewsAPI.deleteExternalNews(id);
        loadExternalNews();
    };

    const openEditModal = (item: ExternalNewsItem) => {
        setEditingExternalNews(item);
        setExternalNewsForm({
            image: item.image || '',
            sourceName: item.sourceName || '',
            title: item.title || '',
            url: item.url || '',
            publishDate: item.publishDate || ''
        });
        setExternalNewsModalVisible(true);
    };

    const openAddModal = () => {
        setEditingExternalNews(null);
        setExternalNewsForm({ image: '', sourceName: '', title: '', url: '', publishDate: '' });
        setExternalNewsModalVisible(true);
    };

    useEffect(() => {
        PostsAPI.getAllPosts().then((res) => {
            setPosts(res);
        });
        loadExternalNews();
    }, []);

    // @ts-ignore
    useEffect(ArticlesAPI.getAllArticles, []);

    useEffect(() => {
        // scroll to top after render and after article loaded
        try{
            setTimeout(() => {
                console.log('scroll to top!!!');
                window.scrollTo({
                    top: 0,
                    behavior: 'auto'
                });
                const element = document.getElementById("header_logo");
                if (element) {
                    element.scrollIntoView({
                        behavior: "auto", // Optional for smooth scrolling
                        block: "start",     // Aligns the element at the top
                    });
                }
            }, 100);
        }catch(exc){

        }
    }, []);

    return (
        <Container>
            <Breadcrumb.Wrapper>
                <Breadcrumb.Item to="/">{t("50w842w7qkv")}</Breadcrumb.Item>
            </Breadcrumb.Wrapper>
            <RowWrapper>
                <h1 className={"new_h1"}>{t("zerd2xf6739")}</h1>
                <Row extra="gap: 15px;">
                    {/*<SelectPlaceholder>*/}
                    {/*    <Select options={AMB_OPTIONS}*/}
                    {/*            value={AMB_OPTIONS.find((i) => i.value === mode) ?? AMB_OPTIONS[0]}*/}
                    {/*            onChange={evt => {*/}
                    {/*                setMode(evt?.value);*/}
                    {/*            }} />*/}
                    {/*</SelectPlaceholder>*/}
                    {role === ERoles.Admin && mode === "platform" && (
                        <Link to="/news/create">
                            <Button>{t("e982jijle5")}</Button>
                        </Link>
                    )}
                    {role === ERoles.Admin && mode === "external" && (
                        <Button onClick={openAddModal}>
                            {isRu ? "Добавить внешнюю новость" : "Add external news"}
                        </Button>
                    )}
                </Row>
            </RowWrapper>

            {mode === "all" && (
                <>
                    {/* Новости программы - сводка */}
                    <SummarySection>
                        <SummarySectionHeader>
                            <SummarySectionTitle>{isRu ? "Новости программы" : "Program news"}</SummarySectionTitle>
                            <ShowAllButton onClick={() => setMode("platform")}>
                                {isRu ? "Показать все" : "Show all"} →
                            </ShowAllButton>
                        </SummarySectionHeader>
                        {articles.length === 0 ? (
                            <div>{isRu ? "Загрузка..." : "Loading..."}</div>
                        ) : (
                            <Row extra={articlesGridWrapperStyles}>
                                {filteredArticles?.slice?.(0, 3)?.map?.((i: any) => (
                                    <Link to={`/news/${i?.id}`} key={i?.id} onClick={() => {
                                        try {
                                            setTimeout(() => {
                                                window.scrollTo({ top: 0, behavior: 'auto' });
                                            }, 30);
                                        } catch (exc) {}
                                    }}>
                                        <NewsTab.Component {...i} />
                                    </Link>
                                ))}
                            </Row>
                        )}
                    </SummarySection>

                    {/* Новости амбассадоров - сводка */}
                    <SummarySection>
                        <SummarySectionHeader>
                            <SummarySectionTitle>{isRu ? "Новости амбассадоров" : "Ambassadors news"}</SummarySectionTitle>
                            <ShowAllButton onClick={() => setMode("ambassadors")}>
                                {isRu ? "Показать все" : "Show all"} →
                            </ShowAllButton>
                        </SummarySectionHeader>
                        {posts.length === 0 ? (
                            <div style={{ padding: '20px', opacity: 0.6 }}>{isRu ? "Загрузка..." : "Loading..."}</div>
                        ) : (
                            <PostsPlaceholder>
                                {renderPosts(posts?.slice?.(0, 4), false, (xId: string) => {
                                    let post = posts.filter((x: any) => x.id === xId)[0];
                                    window.open(`/ambassadors/${post.userId}/posts/${xId}`, "_blank");
                                })}
                            </PostsPlaceholder>
                        )}
                    </SummarySection>

                    {/* О нас говорят - сводка */}
                    <SummarySection>
                        <SummarySectionHeader>
                            <SummarySectionTitle>{isRu ? "О нас говорят" : "Media about us"}</SummarySectionTitle>
                            <ShowAllButton onClick={() => setMode("external")}>
                                {isRu ? "Показать все" : "Show all"} →
                            </ShowAllButton>
                        </SummarySectionHeader>
                        {externalNewsLoading ? (
                            <div>{isRu ? "Загрузка..." : "Loading..."}</div>
                        ) : externalNews.length === 0 ? (
                            <div style={{ padding: '20px', opacity: 0.6 }}>
                                {isRu ? "Пока нет новостей из внешних источников" : "No external news yet"}
                            </div>
                        ) : (
                            <Row extra={articlesGridWrapperStyles}>
                                {externalNews.slice(0, 3).map((item) => (
                                    <ExternalNewsCard
                                        key={item.id}
                                        item={item}
                                        isAdmin={false}
                                        onEdit={() => {}}
                                        onDelete={() => {}}
                                    />
                                ))}
                            </Row>
                        )}
                    </SummarySection>
                </>
            )}

            {mode != "platform" ? null :
                <>
                    <BackToSummaryButton onClick={() => setMode("all")}>
                        ← {isRu ? "Назад к сводке" : "Back to summary"}
                    </BackToSummaryButton>

                    {articles.length == 0 ?
                        <div> {isRu == true ? "Загрузка..." : "Loading..."} </div> : null
                    }

                    <Row extra={articlesGridWrapperStyles}>
                        {filteredArticles?.slice?.(0, maxLength)?.map?.((i: any) => (
                            <Link to={`/news/${i?.id}`} key={i?.id} onClick={() => {
                                try{
                                    setTimeout(() => {
                                        console.log('scroll to top!!!');
                                        window.scrollTo({
                                            top: 0,
                                            behavior: 'auto'
                                        });
                                    }, 30);
                                }catch(exc){

                                }
                            }} >
                                <NewsTab.Component {...i} />
                            </Link>
                        ))}
                    </Row>
                    {filteredArticles?.length > maxLength && (
                        <Button variant="outlined" extra="margin-bottom: 32px;" onClick={handlers.increaseMaxLength}>
                            {t("4ax35e5ajng")}
                        </Button>
                    )}
                </>
            }

            {mode != "ambassadors" ? null :
                <>
                    <BackToSummaryButton onClick={() => setMode("all")}>
                        ← {isRu ? "Назад к сводке" : "Back to summary"}
                    </BackToSummaryButton>
                    <PostsPlaceholder>
                        {renderPosts(posts?.slice?.(0, maxLength), false, xId => {
                            let post = posts.filter(x => x.id == xId)[0];
                            // /ambassadors/:ambassadorId/posts/:postId
                            window.open(`/ambassadors/${post.userId}/posts/${xId}`, "_blank");
                            // window.location.href = `/news/${xId}`;
                        })}
                    </PostsPlaceholder>

                    {posts?.length > maxLength && (
                        <Button variant="outlined" extra="margin-bottom: 32px;" onClick={handlers.increaseMaxLength}>
                            {t("4ax35e5ajng")}
                        </Button>
                    )}

                </>
            }

            {mode != "external" ? null :
                <>
                    <BackToSummaryButton onClick={() => setMode("all")}>
                        ← {isRu ? "Назад к сводке" : "Back to summary"}
                    </BackToSummaryButton>
                    {externalNewsLoading ? (
                        <div>{isRu ? "Загрузка..." : "Loading..."}</div>
                    ) : externalNews.length === 0 ? (
                        <div style={{ padding: '20px', textAlign: 'center', opacity: 0.6 }}>
                            {isRu ? "Пока нет новостей из внешних источников" : "No external news yet"}
                        </div>
                    ) : (
                        <Row extra={articlesGridWrapperStyles}>
                            {externalNews.slice(0, maxLength).map((item) => (
                                <ExternalNewsCard
                                    key={item.id}
                                    item={item}
                                    isAdmin={role === ERoles.Admin}
                                    onEdit={() => openEditModal(item)}
                                    onDelete={() => handleDeleteExternalNews(item.id!)}
                                />
                            ))}
                        </Row>
                    )}

                    {externalNews.length > maxLength && (
                        <Button variant="outlined" extra="margin-bottom: 32px;" onClick={handlers.increaseMaxLength}>
                            {t("4ax35e5ajng")}
                        </Button>
                    )}
                </>
            }

            {/* Modal for adding/editing external news */}
            <Sidebar
                width={Math.min(600, window.innerWidth)}
                visible={externalNewsModalVisible}
                onCloserClick={() => {
                    setExternalNewsModalVisible(false);
                    setEditingExternalNews(null);
                }}
            >
                <ExternalNewsFormWrapper>
                    <h3>{editingExternalNews ? (isRu ? "Редактировать новость" : "Edit news") : (isRu ? "Добавить внешнюю новость" : "Add external news")}</h3>

                    <FormField>
                        <label>{isRu ? "Картинка (URL или загрузка)" : "Image (URL or upload)"}</label>
                        {externalNewsForm.image && (
                            <ImagePreview src={resolveFileUrl(externalNewsForm.image)} />
                        )}
                        <Control.File
                            name="externalNewsImage"
                            multiple
                            maxFilesNumber={1}
                            onChange={(e: any) => {
                                const val = e?.target?.value;
                                if (Array.isArray(val) && val.length > 0) {
                                    setExternalNewsForm({ ...externalNewsForm, image: val[0] });
                                } else if (typeof val === 'string') {
                                    setExternalNewsForm({ ...externalNewsForm, image: val });
                                }
                            }}
                        >
                            <PhotoDropzone />
                        </Control.File>
                    </FormField>

                    <FormField>
                        <label>{isRu ? "Название источника *" : "Source name *"}</label>
                        <input
                            type="text"
                            placeholder={isRu ? "Например: ТАСС, РИА Новости" : "E.g.: TASS, RIA News"}
                            value={externalNewsForm.sourceName}
                            onChange={(e) => setExternalNewsForm({ ...externalNewsForm, sourceName: e.target.value })}
                        />
                    </FormField>

                    <FormField>
                        <label>{isRu ? "Заголовок новости *" : "News title *"}</label>
                        <input
                            type="text"
                            placeholder={isRu ? "Заголовок" : "Title"}
                            value={externalNewsForm.title}
                            onChange={(e) => setExternalNewsForm({ ...externalNewsForm, title: e.target.value })}
                        />
                    </FormField>

                    <FormField>
                        <label>{isRu ? "Ссылка на новость *" : "News URL *"}</label>
                        <input
                            type="url"
                            placeholder="https://..."
                            value={externalNewsForm.url}
                            onChange={(e) => setExternalNewsForm({ ...externalNewsForm, url: e.target.value })}
                        />
                    </FormField>

                    <FormField>
                        <label>{isRu ? "Дата публикации" : "Publication date"}</label>
                        <input
                            type="text"
                            placeholder={isRu ? "Например: 25.11.2025" : "E.g.: 25.11.2025"}
                            value={externalNewsForm.publishDate || ''}
                            onChange={(e) => setExternalNewsForm({ ...externalNewsForm, publishDate: e.target.value })}
                        />
                    </FormField>

                    <ButtonRow>
                        <Button onClick={() => setExternalNewsModalVisible(false)}>
                            {isRu ? "Отмена" : "Cancel"}
                        </Button>
                        <Button onClick={handleSaveExternalNews}>
                            {isRu ? "Сохранить" : "Save"}
                        </Button>
                    </ButtonRow>
                </ExternalNewsFormWrapper>
            </Sidebar>

        </Container>
    );
};

// External news card component
const ExternalNewsCard = ({ item, isAdmin, onEdit, onDelete }: {
    item: ExternalNewsItem;
    isAdmin: boolean;
    onEdit: () => void;
    onDelete: () => void;
}) => {
    const { i18n } = useTranslation();
    const isRu = i18n.language === "ru";

    return (
        <ExternalNewsCardWrapper>
            <ExternalNewsCardClickable onClick={() => window.open(item.url, "_blank")}>
                {item.image ? (
                    <ExternalNewsImage src={resolveFileUrl(item.image)} />
                ) : (
                    <ExternalNewsImagePlaceholder>
                        {item.sourceName?.charAt(0) || "?"}
                    </ExternalNewsImagePlaceholder>
                )}
                <ExternalNewsContent>
                    <ExternalNewsSource>{item.sourceName}</ExternalNewsSource>
                    <ExternalNewsTitle>{item.title}</ExternalNewsTitle>
                    <ExternalNewsFooter>
                        <ExternalNewsLink>{isRu ? "Читать далее" : "Read more"} →</ExternalNewsLink>
                        {item.publishDate && (
                            <ExternalNewsDate>{item.publishDate}</ExternalNewsDate>
                        )}
                    </ExternalNewsFooter>
                </ExternalNewsContent>
            </ExternalNewsCardClickable>
            {isAdmin && (
                <AdminActions>
                    <AdminButton onClick={(e) => { e.stopPropagation(); onEdit(); }}>
                        {isRu ? "Редактировать" : "Edit"}
                    </AdminButton>
                    <AdminButton danger onClick={(e) => { e.stopPropagation(); onDelete(); }}>
                        {isRu ? "Удалить" : "Delete"}
                    </AdminButton>
                </AdminActions>
            )}
        </ExternalNewsCardWrapper>
    );
};

const SelectPlaceholder = styled.div`
  //@media (max-width: 800px) {
  //  display: none;
  //}
`;

const PostsPlaceholder = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
`;

// Summary page styles
const SummarySection = styled.div`
  width: 100%;
  margin-bottom: 40px;
`;

const SummarySectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #02BF89;
`;

const SummarySectionTitle = styled.h2`
  font-family: "Noto Sans", sans-serif;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  color: #333;
`;

const ShowAllButton = styled.button`
  background: none;
  border: none;
  color: #02BF89;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.2s;
  font-family: "Noto Sans", sans-serif;

  &:hover {
    background: rgba(2, 191, 137, 0.1);
  }
`;

const BackToSummaryButton = styled.button`
  background: none;
  border: 1px solid #ddd;
  color: #666;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 10px 20px;
  border-radius: 6px;
  transition: all 0.2s;
  font-family: "Noto Sans", sans-serif;
  margin-bottom: 20px;

  &:hover {
    background: #f5f5f5;
    border-color: #ccc;
  }
`;

const articlesGridWrapperStyles = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: flex-start;
  width: 100%;
  gap: 32px;
  margin-bottom: 30px;

  @media (max-width: 991px) {
    grid-template-columns: repeat(1, 1fr);
  };
`;

const NewsTab = {
    Component: (item: { title: string; cover: string; content: string, customDate: any }) => {
        const { t } = useTranslation();

        return (
            <NewsTab.Wrapper>
                <NewsTab.Image src={resolveFileUrl(item?.cover)} />
                <NewsTab.InnerWrapper>
                    <h4>{item?.title}</h4>
                    {/*<div className="description">{cutString(item?.content?.split?.(`>`)?.[1]?.split?.(`<`)?.[0] ?? ``, 70)}</div>*/}
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        width: "100%"
                    }}>
                        <span>
                            <DormitoryTab.Link color="blue">{t("8obbdg8bgbt")}</DormitoryTab.Link>
                        </span>
                        {(item?.customDate == undefined || item?.customDate == "") ? null :
                            <span style={{ fontSize: "12px", opacity: 0.6 }}>
                                {item?.customDate}
                            </span>
                        }
                    </div>
                </NewsTab.InnerWrapper>
            </NewsTab.Wrapper>
        );
    },
    Wrapper: styled(Frame)`
      width: 100%;
      background: #fdfeff;
      border: 1px solid #e3ecf4;
      border-radius: 12px;
      overflow: hidden;
    `,
    Image: styled(Frame)<{ src: string }>`
      width: 100%;
      height: 224px;
      background: url("${({ src }) => src}") no-repeat center center / cover;
    `,
    InnerWrapper: styled(Frame)`
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      align-items: flex-start;
      gap: 10px;

      > * {
        margin: 0;
      }

      .description {
        font-size: 15px;
        line-height: 20px;
      }
    `
};

// External news styles
const ExternalNewsCardWrapper = styled.div`
  width: 100%;
  background: #fdfeff;
  border: 1px solid #e3ecf4;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const ExternalNewsCardClickable = styled.div`
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }
`;

const ExternalNewsImage = styled.div<{ src: string }>`
  width: 100%;
  height: 180px;
  background: url("${({ src }) => src}") no-repeat center center / cover;
  background-color: #f0f0f0;
`;

const ExternalNewsImagePlaceholder = styled.div`
  width: 100%;
  height: 180px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  font-weight: bold;
  color: white;
`;

const ExternalNewsContent = styled.div`
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ExternalNewsSource = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #667eea;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const ExternalNewsTitle = styled.h4`
  margin: 0;
  font-size: 16px;
  line-height: 1.4;
  color: #212121;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const ExternalNewsFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const ExternalNewsLink = styled.span`
  font-size: 14px;
  color: #02bf89;
  font-weight: 500;
`;

const ExternalNewsDate = styled.span`
  font-size: 12px;
  color: #666;
  opacity: 0.6;
`;

const AdminActions = styled.div`
  display: flex;
  gap: 8px;
  padding: 10px 20px 16px;
  border-top: 1px solid #e3ecf4;
`;

const AdminButton = styled.button<{ danger?: boolean }>`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid ${({ danger }) => (danger ? '#ef4058' : '#ddd')};
  border-radius: 4px;
  background: ${({ danger }) => (danger ? '#fff5f5' : 'white')};
  color: ${({ danger }) => (danger ? '#ef4058' : '#333')};
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${({ danger }) => (danger ? '#ef4058' : '#02bf89')};
    color: white;
    border-color: ${({ danger }) => (danger ? '#ef4058' : '#02bf89')};
  }
`;

const ExternalNewsFormWrapper = styled.div`
  padding: 20px;

  h3 {
    margin: 0 0 20px 0;
  }
`;

const FormField = styled.div`
  margin-bottom: 20px;

  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 14px;
    color: #333;
  }

  input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: #02bf89;
    }
  }
`;

const ImagePreview = styled.img`
  width: 100%;
  max-height: 150px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 10px;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
`;

export default NewsListPage;

/*
Департамент государственной молодежной политики и воспитательной деятельности Минобрнауки России завершил проведение серии акселерационных образовательных программ в сфере молодёжного туризма «Технологии проектирования полезного путешествия в сфере молодежного туризма».


Разработчиком и исполнителем мероприятий выступил Российский государственный университет туризма и сервиса.



Программы были реализованы во всех федеральных округах страны: Центральном (Липецк), Северо-Западном (Луга), Уральском (Салехард), Дальневосточном (Хабаровск), Приволжском (Нижний Новгород), Южном (Волгоград), Северо-Кавказском (Ставрополь) и Сибирском (Новосибирск). Участниками образовательных мероприятий стали практически все регионы Российской Федерации: всего обучение прошли более 800 человек из 78 регионов.



Основной целью проведения программ стало повышение профессиональных компетенций специалистов сферы молодёжного и студенческого туризма, с учетом задач распространения идеологии «полезного путешествия» путем демонстрации культурного, природного, научно-технического, промышленного и предпринимательского потенциала России. Вектор развития этого направления был задан Президентом России Владимиром Путиным по итогам заседания Президиума Госсовета РФ.



В рамках каждой программы проводились пленарные сессии, где обсуждались проблемы, проекты и направления развития молодежного туризма в принимающем федеральном округе. Образовательная часть включала в себя изучение таких вопросов как современные тренды развития молодежного туризма, самые востребованные форматы работы с молодежью при реализации форматов полезного путешествия и другие. Был проведён блок проектной работы и разбор практических ситуаций, возникающих в работе.



В 2024 году планируется масштабирование акселерационных образовательных программ в сфере молодежного туризма.
 */